import { render, staticRenderFns } from "./Nominations.vue?vue&type=template&id=8ced984c&"
import script from "./Nominations.vue?vue&type=script&lang=js&"
export * from "./Nominations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports